// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Jslc","header":"PatientBlock_header__2uNXn","label":"PatientBlock_label__3kFwG","option":"PatientBlock_option__3JxJU"};